import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Card } from '@mui/material';
import { Page } from '@occc-app/design-system';
import config from '@occc/config';
import { routeCreator } from '../retailer-connect.utils';
import { useBreadcrumbLinks } from '../hooks/use-breadcrumb-links.hook';
import { withRetailerNetwork, WithRetailerNetworkProps } from '../hocs/with-retailer-network.hoc';

const PAGE_TITLE = 'Group Details';

const RetailerNetworkMyStoresGroupPage = ({ retailerNetwork }: WithRetailerNetworkProps) => {
  const { groupId } = useParams<{ groupId: string }>();

  const [breadcrumbLinks] = useState(() => [
    { label: 'My Stores', to: routeCreator.myStores(retailerNetwork.uuid) },
    { label: PAGE_TITLE },
  ]);

  useBreadcrumbLinks(breadcrumbLinks);

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: PAGE_TITLE,
        titleTestId: 'rc-group-title',
        subtitle: `${config.brandName} Brand. Page in progress...`,
      }}
      containerProps={{ variant: 'md' }}
    >
      <Card>
        <Typography paragraph align='center' sx={{ my: 3 }}>
          Network ID: {retailerNetwork.uuid} Group ID: {groupId}
        </Typography>
      </Card>
    </Page>
  );
};

export default withRetailerNetwork(RetailerNetworkMyStoresGroupPage);
